import type { FunctionComponent } from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { capitalize } from 'string-ts';

import { Card, CardContent, CardHeader } from '@/components';
import { PIE_COLORS } from '../constants';
import type { DisplayableMetricType } from '../types';

export const TrafficSourcesChart: FunctionComponent<{
  trafficSources: DisplayableMetricType[];
}> = ({ trafficSources }) => (
  <Card className="h-full w-1/2 2xl:!h-1/2 2xl:!w-full">
    <CardHeader className="px-6 pb-2 pt-4 font-bold">Traffic Sources</CardHeader>

    <CardContent className="mt-auto h-4/5 w-full p-2">
      {trafficSources.length > 0 ? (
        <ResponsiveContainer width="90%" height="100%">
          <PieChart>
            <Pie
              data={trafficSources}
              dataKey="value"
              nameKey="label"
              innerRadius={40}
              outerRadius={60}
              startAngle={90}
              endAngle={450}
              width="50%"
              className="focus:outline-none"
            >
              {trafficSources.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={PIE_COLORS[index % PIE_COLORS.length]}
                  stroke="#ffffff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              wrapperStyle={{ width: '50%', maxHeight: '100%' }}
              content={({ payload }) => (
                <div className="flex flex-col space-y-1 2xl:ml-4">
                  {payload?.map((entry, index) => (
                    <div key={`item-${index}`} className="flex items-center space-x-2">
                      <span
                        className="shrink-0 h-2 w-2 rounded-full"
                        style={{
                          backgroundColor: PIE_COLORS[index % PIE_COLORS.length],
                        }}
                      />
                      <div className="flex w-full justify-between">
                        <span
                          className="text-gray-500 whitespace-nowrap 2xl:max-w-20 truncate"
                          title={capitalize(entry.value)}
                        >
                          {capitalize(entry.value)}
                        </span>
                        <span className="font-semibold -mr-6 2xl:-mr-4">
                          {entry.payload?.value}%
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <p>No Traffic Sources Data Available</p>
        </div>
      )}
    </CardContent>
  </Card>
);
